import React, { Component } from 'react'

export default class HospitalLocation extends Component {
  render() {
    return (
      <div>hospitalLocation</div>
    )
  }
}
